export default "__VITE_ASSET__BUPm26Bm__"